import { lazy } from 'react'

export const DownloadV1 = lazy(() => import('./v1/DownloadV1'))
